<template>
  <section class="container">
    <!-- 未登录 -->
    <section class="park_top" v-if="!common.userId" @click="parkSelectFun">
      <img class="top_bg" src="../../../assets/images/park.jpg" />
      <section class="market_box">
        <img :src="require(`../../../assets/images/themes/icon_location_${common.theme}.png`)" />
        <span>{{parkData.parkName}}</span>
        <img v-if="parkList.length > 0" src="../../../assets/images/icon_arrows_filter_normal.png" />
      </section>
      <section class="login_btn" @click.stop="login">登录/注册</section>
    </section>
    <!-- 已登录 -->
    <section class="login_box" v-else @click="parkSelectFun">
      <section class="market_box">
        <img :src="require(`../../../assets/images/themes/icon_location_${common.theme}.png`)" />
        <span>{{parkData.parkName}}</span>
        <img v-if="parkList.length > 0" src="../../../assets/images/icon_arrows_filter_normal.png" />
      </section>
    </section>
    <!-- 车牌号 -->
    <section class="card_box" v-if="showCard">
      <section class="title_box">
        <p class="title">请输入车牌</p>
        <!-- 如果是艾科 且 不是云停车场 显示自助码入口  -->
        <section
          class="code_change"
          v-if="parkData.channelCode == 'ake' && parkData.serverType != 2"
          @click="showCard = false"
        >
          <span>自助码</span>
          <img src="../../../assets/images/icon_indicator_blue.png" />
        </section>
      </section>
      <div class="cardBox" @click="showKeyboard = true">
        <span
          :class="['card_item',(licenseNumber.length == item-1 && showKeyboard)&&common.theme==2?'curS':'',(licenseNumber.length == item-1 && showKeyboard)&&common.theme==1?'curS_2':'']"
          v-for="item in 8"
          :key="item"
        >
          {{licenseNumber[item-1]}}
          <img v-if="item==8" src="../../../assets/images/xny.png" />
        </span>
      </div>
    </section>
    <!-- 自助码 -->
    <section class="card_box" v-if="!showCard">
      <section class="title_box">
        <p class="title">请输入自助码</p>
        <section class="code_change" @click="showCard = true">
          <span>车牌号</span>
          <img src="../../../assets/images/icon_indicator_blue.png" />
        </section>
      </section>
      <div class="cardBox">
        <input
          class="card_input"
          type="tel"
          maxlength="4"
          v-model="cardNum"
          @focus="inputFocus = true"
          @blur="inputFocus = false"
        />
        <span
          :class="['cardbox_item',cardNum.length == index && inputFocus ?'line':'']"
          v-for="(item,index) in 4"
          :key="index"
        >{{cardNum[item-1]}}</span>
      </div>
    </section>
    <!-- 按钮 -->
    <section class="button btn_box" v-if="showCard">
      <p
        :class="['search_btn','btn_default',common.theme==1?'search_btn_2':'']"
        @click="parkingSearchSuccess"
      >查询停车费</p>
    </section>
    <section class="button btn_box" v-else>
      <p
        :class="['search_btn','btn_default',common.theme==1?'search_btn_2':'']"
        @click="parkingSearchSuccessZz"
      >查询</p>
    </section>
    <!-- 历史记录 -->
    <section class="history_data" v-if="showCard">
      <p class="history_title">最近查询</p>
      <img
        @click="clearSearchHistory"
        class="history_delect"
        v-if="searchCardHistory.length"
        src="../../../assets/images/parking/delete.png"
      />
      <section class="history_list">
        <template v-if="searchCardHistory.length">
          <span
            class="list_item"
            v-for="(item,index) in searchCardHistory"
            :key="index"
            @click="search(item)"
          >{{item|filterCarCode}}</span>
        </template>
        <span v-if="!searchCardHistory.length" class="list_item_default">暂无查询历史</span>
      </section>
    </section>
    <!-- 备注 -->
    <section
      class="history_data"
      v-if="showCard && parkData.remarks && parkData.remarks.length > 0"
    >
      <p class="history_title">停车计费规则</p>
      <p class="remark" v-for="item in parkData.remarks" :key="item">{{item}}</p>
    </section>
    <div class="postMessage">
      <div class="enableContract" v-if="parkData.enableDiscount==1">
        <img class="enableContract_icon" src="../../../assets/images/icon_park_notice.png" />
        <span class="enableContract_span1" v-if="!common.userId">该车场已开通临停优惠，请登录认证申请开通</span>
        <span
          class="enableContract_span1"
          v-else-if="discountParklsit.length>0"
        >已申请临停优惠，点击“快速查看”查询申请</span>
        <span class="enableContract_span1" v-else>该车场已开通临停优惠，请申请开通</span>
        <span
          class="enableContract_span2"
          @click="pushToParkingDiscount()"
        >{{discountParklsit.length>0?'快速查看':'快速申请'}}</span>
      </div>
    </div>
    <div class="toast_mask" v-if="showToast">
      <div class="toast_box">
        <p class="toast_title_sty">温馨提示</p>
        <div class="toast_info_sty">{{showToastInfo}}</div>
      </div>
      
    </div>
    <!-- 底部高度 -->
    <section class="footer_height"></section>
    <!-- 键盘 -->
    <mt-popup v-model="showKeyboard" v-if="showCard" position="bottom" :modal="false">
      <key-board
        :keyBoardType="keyBoardType"
        :numClick="numClick"
        :textClick="textClick"
        @hideModal="showKeyboard = false"
        @inputchange="inputchange"
      ></key-board>
    </mt-popup>
    <!-- // 此处slots为动态传入的值，通过computed来处理，数据通过vuex管理，由于数据为对象数组，需设置 value-key 属性来指定显示的字段名 -->
    <mt-popup v-model="parkSelect" position="bottom" class="park_popup">
      <mt-picker
        class="picker"
        :slots="dataList"
        @change="onValuesChange"
        :visible-item-count="5"
        :show-toolbar="true"
        ref="picker"
      >
        <div class="picker_wrap">
          <div class="picker_btn" @click="parkSelect=false">取消</div>
          <div class="picker_btn2" @click="handleConfirm">确认</div>
        </div>
      </mt-picker>
    </mt-popup>
    <!--电子发票公告  -->
    <!-- <mt-popup
      v-model="popupVisible"
      position="center">
      <div class="tipsBox">
        <div class="tipsBox_title">
          <img class="tipsBox_title_icon" src="../../../assets/images/active.png" alt="">
          <div class="tipsBox_title_text">
            电子发票公告
          </div>
        </div>
        <div class="tipsBox_con">
          <p>尊敬的用户您好，为响应国家推行电子发票的号召并确保发票开具时效，自2019年6月17日起，<span>本停车场将全面启用电子发票，不再提供纸质发票。</span></p>
          <p>电子发票支持报销入账，其法律效力、基本用途及使用规定与增值税普通纸质发票一致。</p>
        </div>
        <div class="bottomBtn tipsBox_btn">
知道了
        </div>
      </div>
    </mt-popup>-->

    <!--查询停车记录失败  -->
    <mt-popup popup-transition="popup-fade" v-model="popupVisibleSearch" position="center">
      <div class="searchFail">
        <img class="searchFail_icon" src="../../../assets/images/parkService/searchFail.jpg" alt />
        <div class="searchFail_number">{{parkNumber|filterCarCode}}</div>
        <div class="searchFail_text">未查询到该车辆的订单~</div>
        <div class="button">
          <div class="tipsBox_btn btn_default" @click="popupVisibleSearch=false">知道了</div>
        </div>
      </div>
    </mt-popup>
  </section>
</template>

<script>
import {
  mapState
} from 'vuex';
import keyBoard from './keyboard';
import util from '../../../utils/util';
import { freeCall, loadParkHeaderById } from '../../../utils/api'
import storage from "../../../utils/storage";
export default {
  name: 'parkingSearch',
  props: {
    parkData: {
      type: Object,
      default() { return {} }
    },
    parkName: {
      type: String,
      default: ''
    },
    parkList: {
      type: Array,
      default() { [] }
    },
    refush: {
      type: Object,
      default() { return {} }
    },
  },
  components: {
    keyBoard
  },
  watch: {
    parkData() {
      if (this.common.userId) {
        this.getMyDiscountParkLot();
      }
    },
    refush() {
      if (this.refush && this.common.userId) {
        this.getMyDiscountParkLot();
      }
    }
  },
  filters: {
    filterCarCode(value) {
      return value ? value.slice(0, 2) + '·' + value.slice(2) : '';
    }
  },
  computed: {
    defaultTenant() {
      let data = this.common.userTenantInfoList || [];
      let defaultD = {};
      data.forEach(item => {
        if (item.isDeafult == 1) {
          defaultD = item;
        }
      });
      return defaultD;
    },
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
      showCard: true,
      canPost:true,
      cardNum: '',
      inputFocus: false,//是否聚焦
      parkSelect: false,
      licenseNumber: [],
      userSelect: 0,
      showKeyboard: false, // 是否显示键盘
      keyBoardType: 1, // 键盘类型
      numClick: 2, // 数字是否可点 2:不可点
      textClick: 2, // 文字是否可点2:不可点
      discountParklsit: '',
      dataList: [{
        flex: 1,
        values: [],
        className: 'slot1',
        textAlign: 'center'
      }],
      parkNumber: "",
      searchCardHistory: [], //查询历史
      popupVisibleSearch: false,
      popupVisible: true,
      value: 10,
      showToast:false,
      showToastInfo:'2222'
    }
  },
  mounted() {
    console.log(this.parkList);
    if(this.parkList[0].temporaryBillType==2){
      this.showToast = true
      this.showToastInfo= '当前码已失效，请扫描车场最新二维码！'
    }else{
      this.showToast = false
      this.showToastInfo = ''
    }
    this.getHistory();
    if (this.common.userId) {
      this.getMyDiscountParkLot()
    }
    util.hideLoading();
  },
  methods: {
    getMyDiscountParkLot() {
      let params = {
        subProjectId: this.common.marketInfo.id,
        parkHeaderId: this.parkData.id,
        phone: this.common.userInfo.account || this.common.userInfo.phone,
        url: "/parking/rstParkLot/loadDiscountParkLot"
      }
      loadParkHeaderById(params).then(res => {
        if (res.res && res.res.code === 10000 && res.body) {
          this.discountParklsit = res.body.data;
        }
      })
    },
    login() {
      this.$router.push(`/login?parkingSearch=parkingService`);
    },
    search(parkNumber) {
      if(this.canPost==false){
         util.showToast("请勿频繁查询")
         return;
      }
      this.canPost = false
      setTimeout(() => {
          this.canPost =true
      }, 2000);
      this.showKeyboard = false
      let postInfo = {
        'parkHeaderId': this.parkData.id,
        'plateNo': parkNumber,
        'url': '/parking/rstParkBill/getParkFee'
      }
      this.parkNumber = parkNumber
      util.showLoading("查询中...");
      freeCall(postInfo).then(res => {
        util.hideLoading();
        if (res.res.code == 10000) {
          storage.set('parkingSearchSuccess', JSON.stringify(res.body.data))
          this.$router.push(`/parkingSearchSuccess?outEffectiveTime=${this.parkData.outEffectiveTime}&parkHeaderId=${this.parkData.id}&plateNo=${parkNumber}`);
        } else {
          this.popupVisibleSearch = true
        }
      })
    },
    getHistory() {

        console.log("In getHistory")
        this.searchCardHistory = storage.get('searchCardHistory') ? JSON.parse(storage.get('searchCardHistory')) : []
       // 自从把iOS中的WebView换成WKWebView后，首次加载h5页面，h5页面中的js就拿不到localstorage了
        console.log("In getHistory" + JSON.stringify(this.searchCardHistory))
        if(!this.searchCardHistory || this.searchCardHistory.length==0 ){
          console.log("in no searchCardHistory ")
            // window.location.reload()
            setTimeout(() => {
              this.searchCardHistory = storage.get('searchCardHistory') ? JSON.parse(storage.get('searchCardHistory')) : []
          }, 3000);
        }
   },
    clearSearchHistory() {
      let self = this;
      util.showModal('', '确定删除查询记录吗?', true, '确定', () => {
        storage.set('searchCardHistory', JSON.stringify([]))
        self.getHistory();
      }, () => { })
    },
    parkingSearchSuccess() {
      this.showKeyboard = false
      let len = this.licenseNumber.length
      let parkNumber = this.licenseNumber.join('')
      this.parkNumber = parkNumber
      if (len < 1) {
        util.showToast("请输入车牌号");
        return
      }

      if (!util.isLicensePlate(parkNumber)) {
        util.showToast("请输入合法车牌号");
        return
      }

       if(this.canPost==false){
         util.showToast("请勿频繁查询")
         return;
      }
      this.canPost = false
      setTimeout(() => {
          this.canPost =true
      }, 2000);

      let postInfo = {
        'parkHeaderId': this.parkData.id,
        'plateNo': parkNumber,
        'url': '/parking/rstParkBill/getParkFee'
      }
      util.showLoading("查询中...");
      freeCall(postInfo).then(res => {
        util.hideLoading();
        if (this.searchCardHistory.indexOf(parkNumber) == -1 && this.searchCardHistory.length > 2) {
          this.searchCardHistory.splice(0, 1)
          this.searchCardHistory.push(parkNumber)
        } else if (this.searchCardHistory.indexOf(parkNumber) == -1 && this.searchCardHistory.length < 3) {
          this.searchCardHistory.push(parkNumber)
        }
        storage.set('searchCardHistory', JSON.stringify(this.searchCardHistory))
        this.getHistory();

        if (res.res.code == 10000) {
          storage.set('parkingSearchSuccess', JSON.stringify(res.body.data))
          this.$router.push(`/parkingSearchSuccess?outEffectiveTime=${this.parkData.outEffectiveTime}&parkHeaderId=${this.parkData.id}&plateNo=${parkNumber}`);
        } else {
          this.popupVisibleSearch = true
        }

      });
    },
    // 自助码查询
    parkingSearchSuccessZz() {
      util.showLoading()
      if (!this.cardNum) {
        util.showToast("请输入自助码");
        return false;
      } else if (this.cardNum.length !== 4) {
        util.showToast("请输入4位自助码");
        return false;
      }
      this.$router.push(`/parkingScanDetail/${this.parkData.parkCode}/${this.cardNum}/2?come=parkingSearch`);
      // let params = {
      //   parkCode:this.parkData.parkCode,//车场编号
      //   randomCode:this.cardNum,//随机码
      //   userUniqCode:this.common.openId,
      //   url:'/parking/rstParkBill/randomChannel'
      // }
      // freeCall(params).then(res=>{
      //   console.log(res)
      //   util.hideLoading()
      //   if(res.res.code === 10000){
      //     this.$router.push(`/parkingScanDetail/${this.parkData.parkCode}/${this.cardNum}/2`);
      //   }else{
      //     util.showToast(res.res.msg,2000)
      //   }
      // })
    },
    pushToParkingDiscount() {
      if (this.common.userId) {
        if (this.defaultTenant.company) {
          if (this.discountParklsit.length > 0) {
            this.$router.push(`/discountList?outEffectiveTime=${this.parkData.outEffectiveTime}&parkHeaderId=${this.parkData.id}`);
          } else {
            this.$router.push(`/parkingDiscount?outEffectiveTime=${this.parkData.outEffectiveTime}&parkHeaderId=${this.parkData.id}`);
          }
        } else {

          util.showModal('', '请先认证，再申请临停优惠', true, '立即认证', () => {
            this.$router.push({
              path: `/addCompany?isToAddPhone=` + false
            });
          })


        }

      } else {
        this.login();
      }
    },
    inputchange(value) {
      let arr = this.licenseNumber;
      if (arr.length === 8 && value !== 'delete') {
        return;
      }
      // 切换键盘
      if (this.keyBoardType === 1) {
        if (value === 'delete') {
          this.hideModal();
        } else {
          this.keyBoardType = 2;
          arr.push(value);
        }
      } else {
        if (value === 'delete') {
          arr.splice(-1, 1);
          if (arr.length === 0) {
            this.keyBoardType = 1;
          }
        } else {
          arr.push(value);
        }
      }

      if (arr.length > 0) {
        this.numClick = 1;
      } else {
        this.numClick = 2;
      }
      if (arr.length > 5) {
        this.textClick = 1;
      } else {
        this.textClick = 2;
      }
    },
    parkSelectFun() {
      if (this.parkList.length === 0) {
        return;
      }
      this.parkSelect = true
      this.dataList[0].values = []
      this.parkList.forEach(item => {
        this.dataList[0].values.push(item.parkName)
      })
    },
    onValuesChange(picker, values) {
      if (values[0] > values[1]) {
        picker.setSlotValue(1, values[0]);
      }
    },
    handleConfirm() {
      this.parkSelect = false
      var value = this.$refs.picker.getValues()[0];
      this.$emit('parkSelect', value);
      // this. getMyDiscountParkLot();

    },
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.container {
  .mint-popup {
    background: rgba(0, 0, 0, 0);
  }
}
.park_popup {
  background: #fff !important;
}
// 头部
.park_top {
  height: 240px;
  position: relative;
  .top_bg {
    width: 100%;
    height: 100%;
  }
  .market_box {
    position: absolute;
    top: 24px;
    left: 28px;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    height: 60px;
    background: rgba(0, 0, 0, 0.04);
    border-radius: 30px;
    padding: 0 20px 0 12px;
    img {
      width: 32px;
      height: 32px;
      margin-right: 8px;
    }
  }
  .login_btn {
    position: absolute;
    top: 24px;
    right: 28px;
    width: 140px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    box-sizing: border-box;
    .border(#1740da);
    color: #1740da;
    font-size: 24px;
    border-radius: 8px;
  }
}
.login_box {
  height: 108px;
  position: relative;
  .market_box {
    position: absolute;
    top: 24px;
    left: 28px;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    height: 60px;
    background: rgba(0, 0, 0, 0.04);
    border-radius: 30px;
    padding: 0 20px 0 12px;
    img {
      width: 32px;
      height: 32px;
      margin-right: 8px;
    }
  }
}
.card_box {
  margin-top: 48px;
  .title_box {
    position: relative;
  }
  .title {
    font-size: 40px;
    color: rgba(51, 51, 51, 1);
    line-height: 56px;
    text-align: center;
    font-weight: bold;
  }
  .code_change {
    position: absolute;
    top: 0;
    right: 40px;
    width: 140px;
    height: 56px;
    background: rgba(244, 244, 244, 1);
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    span {
      font-size: 28px;
      color: rgba(23, 64, 218, 1);
      margin-left: 8px;
    }
    img {
      width: 32px;
      height: 32px;
    }
  }
}
.btn_box {
  margin: 0 40px 60px;
  .search_btn {
    height: 88px;
    line-height: 88px;
    text-align: center;
    color: #fff;
    background: @color17;
    border-radius: 8px;
    font-size: 32px;
    box-shadow: 0 8px 16px 0 rgba(195, 202, 229, 1);
  }
  .search_btn_2 {
    box-shadow: 0 8px 16px 0 rgba(243, 235, 203, 1);
  }
}
// 车牌号
.cardBox {
  .flex();
  justify-content: center;
  margin: 60px 0;
  background: #fff;
  position: relative;
  .card_item {
    width: 72px;
    height: 84px;
    line-height: 84px;
    border-radius: 4px;
    // .border_2px(rgba(224,224,224,1));
    border: 2px solid rgba(224, 224, 224, 1);
    text-align: center;
    margin: 0 5px;
    position: relative;
    font-size: 40px;
    // font-weight: bold;
    &:last-child {
      background: rgba(243, 251, 249, 1);
      .border_2px(rgba(198,238,225,1));
    }
    img {
      display: block;
      width: 80px;
      height: 30px;
      position: absolute;
      top: -18px;
      left: 50%;
      transform: translate(-50%);
    }
  }
  .curS {
    .border_2px(rgba(23,64,218,1));
    &:last-child {
      .border_2px(rgba(23,64,218,1));
    }
  }
  .curS_2 {
    .border_2px(#333333);
  }
  .cardbox_item {
    width: 112px;
    height: 112px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    border-bottom: 4px solid #999;
    margin: 0 20px;
    position: relative;
    font-size: 60px;
    // font-weight:bold;
    color: rgba(23, 64, 218, 1);
  }
  .line {
    &:after {
      content: "";
      position: absolute;
      width: 4px;
      height: 60px;
      background: rgba(23, 64, 218, 1);
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .card_input {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 2;
    opacity: 0;
  }
}
// 历史记录
.history_data {
  position: relative;
  padding: 0 40px 20px;
  .history_title {
    font-size: 32px;
    color: #333;
    line-height: 44px;
    height: 44px;
    text-align: left;
    position: relative;
    margin-bottom: 28px;
    // &:after {
    //     content: '';
    //     position: absolute;
    //     left: 50%;
    //     top: 50%;
    //     transform: translate(0,-50%);
    //     margin-left: -330px;
    //     height: 2px;
    //     width: 250px;
    //     background: #eaeaea;
    // }
    // &:before {
    //     content: '';
    //     position: absolute;
    //     left: 50%;
    //     top: 50%;
    //     transform: translate(0,-50%);
    //     margin-left: 80px;
    //     height: 2px;
    //     width: 250px;
    //     background: #eaeaea;
    // }
  }
  .history_delect {
    position: absolute;
    top: 0;
    right: 40px;
    width: 64px;
    height: 44px;
    background: #fff;
    padding-left: 20px;
    box-sizing: border-box;
  }
  .remark {
    font-size: 26px;
    color: #999;
    line-height: 36px;
  }
  .history_list {
    .flex();
    flex-direction: row;
    flex-wrap: wrap;
    .list_item {
      width: 218px;
      height: 68px;
      line-height: 68px;
      background: rgba(248, 248, 248, 1);
      border-radius: 8px;
      text-align: center;
      font-size: 30px;
      color: #333;
      margin-right: 20px;
      margin-bottom: 20px;
    }
    .list_item_default {
      font-size: 32px;
      font-weight: 400;
      color: rgba(201, 201, 201, 1);
      line-height: 44px;
    }
  }
}
// 电子发票公告
.searchFail,
.tipsBox {
  width: 600px;
  height: 720px;
  border-radius: 16px;
  padding: 60px 40px 0;
  box-sizing: border-box;
  .tipsBox_title {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
    .tipsBox_title_icon {
      width: 32px;
      height: 32px;
      margin-right: 20px;
    }
    .tipsBox_title_text {
      height: 56px;
      font-size: 40px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 56px;
    }
  }
  .tipsBox_con {
    p,
    span {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 48px;
    }
    span {
      color: #ff981e;
    }
  }
  .tipsBox_btn {
    width: 520px;
    height: 76px;
    background: rgba(23, 64, 218, 1);
    border-radius: 8px;
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 76px;
    text-align: center;
    margin-top: 70px;
  }
}
.searchFail {
  width: 600px;
  height: 720px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  .searchFail_icon {
    width: 176px;
    height: 224px;
    margin-top: 60px;
    margin-bottom: 40px;
  }
  .searchFail_number {
    height: 66px;
    font-size: 48px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 66px;
    letter-spacing: 1px;
    margin-bottom: 20px;
  }
  .searchFail_text {
    height: 44px;
    font-size: 32px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    line-height: 44px;
  }
}
.picker {
  width: 100%;
}
.picker-items {
  height: 100px !important;
}
.picker_wrap {
  height: 100px;
  display: flex;
  justify-content: space-between;
  padding: 0 28px;
  box-sizing: border-box;
}
.picker_btn,
.picker_btn2 {
  flex: 1;
  font-size: 32px;
  text-align: left;
  line-height: 100px;
}
.picker_btn2 {
  text-align: right;
  color: @color17;
}
.footer_height {
  height: 108px;
}

.postMessage {
  position: absolute;
  left: 0;
  bottom: 108px;
  width: 750px;
  // height: 100px;
  background-color: wheat;
}
.enableContract {
  width: 750px;
  height: 80px;
  display: flex;
  background: rgba(240, 245, 252, 1);
  flex-direction: row;
  align-items: center;
}
.enableContract_icon {
  width: 32px;
  height: 32px;
  margin-left: 30px;
}
.enableContract_span1 {
  width: 550px;
  margin-left: 14px;
  height: 34px;
  font-size: 24px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 34px;
  display: flex;
}
.enableContract_span2 {
  width: 124px;
  height: 34px;
  font-size: 24px;
  font-weight: 400;
  color: rgba(23, 64, 218, 1);
  line-height: 34px;
}
.toast_mask{
  position:fixed;
  top:0;
  left:0;    
  width: 100%;
  height: 100vh;
  background: #a09e9e;
  z-index: 999;
}
.toast_box{
  width: 500px;
  height: 180px;
  background: #fff;
  border-radius: 4px;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 30px;
  .toast_title_sty{
    height: 60px;
    line-height: 60px;
    text-align: center;
    border-bottom: 1px solid #ccc;
  }
  .toast_info_sty{
    text-align: center;
    padding: 20px;
  }
}
</style>
